import React from 'react';
import { Paper, Typography, Divider, Link } from '@mui/material';
import webIcon from '../../assets/web.png';
import PhoneIcon from '../../assets/phone.png';
import emailIcon from '../../assets/email.png';
import locationIcon from '../../assets/location.png';
import { getEventStatus } from '../../utils';
import { EventDetail } from '../../types';
import { usePublicSettings } from '../../hooks/usePublicSettings';

interface EventStatusPaperProps {
    event: EventDetail;
    selectedChildId?: number;
}

const EventStatusPaper: React.FC<EventStatusPaperProps> = ({ event, selectedChildId }) => {
    const { className } = getEventStatus(event, selectedChildId);
    const { website, phone, email } = usePublicSettings();
    const eventAddress = event?.location?.address ?
      `${event?.location?.address}${event?.location?.address2 ? ', ' + event?.location?.address2 : ''}${event?.location?.city ? ', ' + event?.location?.city : ''}${event?.location?.region ? ', ' + event?.location?.region : ''}${event?.location?.postal ? ', ' + event?.location?.postal : ''}` : '';

    return (
        <Paper elevation={3} className={`events-paper ${className}`}>
            <div className="p-5">
                {website && (
                    <>
                        <div className="flex items-center">
                            <img src={webIcon} alt="Calendar" style={{ width: '15px', height: '15px', marginRight: '10px' }} />
                            <Link href={website} target="_blank" rel="noopener" underline="hover">
                                Visit Website
                            </Link>
                        </div>
                        <Divider className="pb-3" />
                    </>
                )}
                {phone && (
                    <>
                        <div className="flex items-center pt-3">
                        <img src={PhoneIcon} alt="Calendar" style={{ width: '15px', height: '15px', marginRight: '10px' }} />
                            <Typography>{phone}</Typography>
                        </div>
                        <Divider className="pb-3" />
                    </>
                )}
                {email && (
                    <>
                        <div className="flex items-center pt-3">
                            <img src={emailIcon} alt="Email" style={{ width: '15px', height: '11px', marginRight: '10px' }} />
                            <Link href={`mailto:${email}`} underline="hover">
                                {email}
                            </Link>
                        </div>
                        <Divider className="pb-3" />
                    </>
                )}
                {eventAddress.length && (
                    <>
                        <div className="flex items-center pt-3">
                            <img src={locationIcon} alt="Location" style={{ width: '13px', height: '15px', marginRight: '10px' }} />
                            <Typography>{eventAddress}</Typography>
                        </div>
                    </>
                )}
            </div>
        </Paper>
    );
};

export default EventStatusPaper;
